import { Editor, Range, Element as SlateElement, Transforms } from 'slate'
import { ReactEditor } from 'slate-react'
import { CustomEditor, LinkElement } from 'modules/community/types/custom-editor'
import { isBlockActive } from './core'

export const insertLink = (editor: Editor, url: string): void => {
  if (!editor.selection) {
    const endOfDoc = Editor.end(editor, [])
    if (endOfDoc) {
      Transforms.select(editor, endOfDoc)
    }
  }
  wrapLink(editor, url)
  ReactEditor.focus(editor)
}

export const unwrapLink = (editor: CustomEditor): void => {
  Transforms.unwrapNodes(editor, {
    match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'link',
  })
}

export const wrapLink = (editor: CustomEditor, url: string): void => {
  if (isBlockActive(editor, 'link')) {
    unwrapLink(editor)
  }

  const { selection } = editor
  const isCollapsed = selection && Range.isCollapsed(selection)

  const link: LinkElement = {
    type: 'link',
    url,
    children: isCollapsed ? [{ text: url }] : [],
  }

  if (isCollapsed) {
    Transforms.insertNodes(editor, link)
    Transforms.move(editor, { unit: 'offset' })
    Transforms.insertNodes(editor, { text: ' ' })
  } else {
    Transforms.wrapNodes(editor, link, { split: true })
    Transforms.collapse(editor, { edge: 'end' })
    Transforms.move(editor, { unit: 'offset' })
  }
}
